module.exports = __webpack_public_path__ + "media/images/client-1-b91084aeb13adf15256b1e3aae9b98c0.png";